
export default {
  props: {
    breadcrumbs: {
      type: Array,
      required: true,
    },
  },

  computed: {
    filteredBreadcrumbs() {
      return this.breadcrumbs.filter((breadcrumb) => breadcrumb.url !== '/blog')
    },

    back() {
      return this.$router.back()
    },
  },
}
